module.exports = __webpack_public_path__ + "static/media/Item 11.b2a54127.jpg";